"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProtectionOrderError = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
const types_1 = require("../types");
const generalUtils_1 = require("./generalUtils");
const getProtectionOrderError = (direction, variant, value, limitingPrice, precisionLimit) => {
    if (!value)
        return undefined;
    const { isLong, isShort } = (0, generalUtils_1.distilMarginInformation)(direction);
    const isStopLoss = variant === types_1.ProtectionOrderVariant.StopLoss;
    if ((0, generalUtils_1.isExceedingPrecision)((0, big_1.default)(limitingPrice).toString(), precisionLimit))
        return types_1.ProtectionOrderError.TooMuchPrecision;
    if (isStopLoss) {
        if (isLong && (0, big_1.default)(value).gte(limitingPrice))
            return types_1.ProtectionOrderError.StopLossAboveMax;
        if (isShort && (0, big_1.default)(value).lte(limitingPrice))
            return types_1.ProtectionOrderError.StopLossBelowMin;
    }
    else {
        if (isLong && (0, big_1.default)(value).lte(limitingPrice))
            return types_1.ProtectionOrderError.TakeProfitBelowMin;
        if (isShort && (0, big_1.default)(value).gte(limitingPrice))
            return types_1.ProtectionOrderError.TakeProfitAboveMax;
    }
    return undefined;
};
exports.getProtectionOrderError = getProtectionOrderError;
//# sourceMappingURL=protectionOrderErrors.js.map